import { Dices, Map, Waypoints } from "lucide-react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";

const BONUS = [
  {
    icon: Map,
    title: "Landmark & Tube guide",
    body: "A handy guide to London's famous attractions — with the Underground stations and Tube lines to help you find them.",
  },
  {
    icon: Waypoints,
    title: "Finger maze",
    body: "A winding finger maze on the back page — little hands trace their way across the city.",
  },
  {
    icon: Dices,
    title: "Board game adventure",
    body: "A London-themed board game built into the book. Just add dice and a token and play together.",
    download: true,
  },
];

export default function BonusFeatures() {
  return (
    <section data-testid="bonus-features" className="bg-walnut text-cream border-t border-cream/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-10">
          <div>
            <Eyebrow className="mb-3 !text-terracotta">Bonus fun inside</Eyebrow>
            <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl">
              Bailey in London is more than a story
            </h2>
          </div>
          <Link
            to="/books/bailey-in-london"
            data-testid="bonus-features-cta"
            className="group inline-flex items-center gap-2 text-sm font-display font-bold text-terracotta hover:gap-3.5 transition-all shrink-0"
          >
            See the book <ArrowRight size={16} />
          </Link>
        </Reveal>

        <div className="grid sm:grid-cols-3 gap-5">
          {BONUS.map((b, i) => (
            <Reveal key={b.title} delay={i * 0.1}>
              <div
                data-testid={`bonus-card-${b.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group h-full rounded-3xl border border-cream/15 bg-cream/5 p-7 hover:bg-cream/10 hover:-translate-y-1.5 transition-all duration-300"
              >
                <span className="inline-flex w-12 h-12 rounded-2xl bg-terracotta/20 items-center justify-center mb-5 group-hover:bg-terracotta/30 transition-colors">
                  <b.icon size={22} className="text-terracotta" />
                </span>
                <h3 className="font-display font-bold text-lg sm:text-xl tracking-tight mb-2">{b.title}</h3>
                <p className="text-sm text-cream/65 leading-relaxed">{b.body}</p>
                {b.download && (
                  <a
                    href="#worksheets"
                    onClick={(e) => {
                      e.preventDefault();
                      const el = document.getElementById("worksheets");
                      if (el) window.__lenis ? window.__lenis.scrollTo(el, { offset: -70 }) : el.scrollIntoView({ behavior: "smooth" });
                    }}
                    data-testid="bonus-download-game"
                    className="mt-4 inline-flex items-center gap-2 text-sm font-display font-bold text-terracotta hover:gap-3 transition-all"
                  >
                    Get the printable game — £1 <ArrowRight size={15} />
                  </a>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
